import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Link } from 'gatsby';
import AnchorLink from 'react-anchor-link-smooth-scroll';

import { ButtonStyles } from '../Button/styles';

const LinkStyles = css`
  color: black;
  text-decoration: none;

  margin-bottom: 1rem;
  &:hover,
  &:focus {
    color: ${themeGet('colors.spinDark')};
    transition: all 500ms ease;
  }

  &.inline {
    margin-bottom: 0px;
    border-bottom: none;
    display: inline-block;
    margin-right: 1rem;
    &:last-child {
      margin-right: 0rem;
    }
    &:hover,
    &:focus {
      opacity: 0.8;
      border-bottom: none;
      &.button {
        opacity: 1;
      }
    }
  }

  /* HOVER ANIMATION */
  &.hvr-bounce-to-right {
    transform: perspective(1px) translateZ(0);
    position: relative;
    transition-duration: 0.5s;
    overflow: hidden;
  }
  &.hvr-bounce-to-right:before {
    content: '';
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${themeGet('colors.spinSecondaryOne')};
    width: 0;
    /* border-radius: 36.5px; */
    /* transform: scaleX(0);
    transform-origin: 0 50%;*/
    transition-property: width;
    transition-duration: 0.5s;
    transition-timing-function: ease-out;
  }
  &.hvr-bounce-to-right:hover:before,
  .hvr-bounce-to-right:focus:before,
  .hvr-bounce-to-right:active:before {
    /* transform: scaleX(1); */
    width: 100%;
    transition-timing-function: cubic-bezier(0.52, 1.64, 0.37, 0.66);
  }

  &.card-link {
    color: #0526a5;
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 1.625rem;
    word-break: break-all;
    @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
      font-size: 1rem;
      line-height: 1.625rem;
    }
  }

  ${ButtonStyles}
`;

export const InternalStyledLink = styled(Link)`
  ${LinkStyles}
`;

export const ExternalStyledLink = styled.a.attrs(({ isSpecialLink }) => ({
  target: isSpecialLink ? '' : '_blank',
  rel: isSpecialLink ? '' : 'noopener noreferrer',
}))`
  ${LinkStyles}
`;
export const LinkWrapper = styled.span`
  &::before {
    display: block;
    content: attr(title);
    font-weight: 600;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
`;
